export enum QUERY_PARAMS {
	FORM_ID = 'formId',
	FORM_TOKEN = 'formToken',
	SUBMISSION_ID = 'submissionId',
	FILTERS = 'filters',
	SEARCH = 'search',
	SORT = 'sort',
	TAB = 'tab',
	CHECKOUT = 'checkout',
	PAGE_ID = 'page_id',
	REDIRECT_PATH = 'redirectPath',
	AUTH_TYPE = 'authType',
	AUTH_TOKEN = 'token',
	IMPORT_ID = 'importId',
	SETTINGS = 'settings',
	ANALYTICS = 'analytics',
	SCHEDULE_MODAL = 'scheduleModal',
	REFRESH_TOKEN = 'refreshToken',
	FOCUS_MODE_TAB = 'focusModeTab',
	FEEDBACK_FOR = 'feedbackFor',
	REFERRAL = 'referral',
	SOURCES = 'sources',
	ONBOARDING = 'onboarding',
	PUBLISH = 'publish',
	PROMPT = 'prompt',
	CHANGELOG_ENTRY = 'entry',
}
